import { Assessment, AssessmentType, BenchmarkAssessment, BenchmarkPeriod } from 'types';

export const getFormattedDate = (date: Date): string => {
  const year = date.getFullYear();
  const month = (1 + date.getMonth()).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');

  return month + '/' + day + '/' + year;
};

interface CurriculumBenchmarkAssessment extends Omit<BenchmarkAssessment, 'details'> {
  productCurriculumId: number;
  period: BenchmarkPeriod;
}

export const getCurriculumBenchmarkAssessment = (
  assessment: BenchmarkAssessment,
  productCurriculumId: number
) => {
  const { details, ...rest } = assessment as BenchmarkAssessment;
  const curriculumDetails = details.find((x) => x.productCurriculumId === productCurriculumId)!;

  return {
    ...rest,
    productCurriculumId: curriculumDetails.productCurriculumId,
    period: curriculumDetails.period,
  };
};

export const getCurriculumBenchmarkAssessments = (
  assessments: Assessment[] = [],
  productCurriculumId: number
): CurriculumBenchmarkAssessment[] =>
  assessments
    .filter(
      (assessment) =>
        assessment.type === AssessmentType.Benchmark &&
        (assessment as BenchmarkAssessment).details.some(
          (x) => x.productCurriculumId === productCurriculumId
        )
    )
    .map((assessment) =>
      getCurriculumBenchmarkAssessment(assessment as BenchmarkAssessment, productCurriculumId)
    );
